import EventActionProto from '../event-action-proto'

module.exports = class EventStatusResetByCompany extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false);
        this.restartApps = ['organization-settings-task-type','organization-settings-project-type'];
    }

    validate() {
        return true;
    }

    process() {
        const companyId = this.data[0].companyId

        gd.session.statuses.resetAndMarkOldModelsAsDeleted(this.data, companyId)

        gd.session.taskTypes.reinit();
        // gd.session.projectTypes.reinit();

        super.process();
    }
};

